export const PropertyTaxesInfo = {
  TITLE: 'Property Taxes',
  KEY: 'propertyTaxes',
  PENDING_CHANGES_KEY: 'propertyTaxesPendingChanges',
};

export const TableColumnId = {
  IMPOUND_TYPE_ID: 'impoundTypeId',
  MONTHLY_AMOUNT: 'monthlyAmount',
};

export const defaultSortOrder = {
  direction: 'desc',
  id: 'name',
};
